<template>
  <div class="file-card text-center">
    <div class="icon-wrapper mx-auto mb-3">
        <FontAwesomeIcon icon="fa-solid fa-user-plus" class="text-shareguard icon-inner" />
    </div>
    <p class="file-title fw-bold mb-1">No contacts found</p>
    <p class="file-meta text-muted mb-3">Add a contact to get started</p>
    <button class="btn btn-dark btn-sm px-4 py-2" @click="addContactClick">Add Contact</button>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'EmptyStateContacts',
  components: {
    FontAwesomeIcon
  },
  props: {
    addContact: {
      type: Function,
      required: true
    }
  },
  emits: ['addContact'],
  methods:{
    addContactClick() {
        this.$emit('addContact');
    }
  }
}
</script>

<style scoped>
.file-card {
  border: 2px dotted #dee2e6; /* light gray dotted border */
  border-radius: 12px;
  padding: 32px 24px;
  background-color: #fff;
  /* max-width: 400px; */
  margin: auto;
}

.icon-wrapper {
  background-color: #e9ecef; /* light background circle */
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-inner {
  font-size: 36px;
}

.file-title {
  font-size: 1.1rem;
}

.file-meta {
  font-size: 0.9rem;
}
</style>


